const loggedReducer = (state = false, action = {}) => {
  if (action.type === 'SHOWSXP') {
    return !state
  } else {
    return state
  }
}

export default loggedReducer
